import React from 'react';

const Contact = () => {
    return (
        <div>
            <h4 className='mt-3'>For more information or Talk to me, Please Contact:</h4>
            <h2>+068856249</h2>
        </div>
    );
};

export default Contact;